import { duration } from "../dateUtils.mjs";
function createPayloadEncoder(getReplicant, analytics, opts) {
  const generatePayloadKey = (opts == null ? void 0 : opts.generatePayloadKey) ?? createPayloadKeyGenerator(getReplicant);
  const payloadEncoder = {
    encode: (payload) => {
      const replicant = getReplicant();
      const key = generatePayloadKey();
      const expiresInMs = duration({ days: 365 });
      replicant.kvStore.send(key, JSON.stringify(payload), { expiresInMs }).catch((err) => {
        trackPayloadWriteFailure(analytics, err, {
          key,
          channel: payload.$channel,
          feature: payload.feature,
          subFeature: payload.$subFeature,
          playerID: payload.playerID
        });
      });
      return {
        $key: key,
        $channel: payload.$channel,
        feature: payload.feature,
        $subFeature: payload.$subFeature,
        playerID: payload.playerID
      };
    },
    decode: async (entryData) => {
      const replicant = getReplicant();
      const key = entryData.$key;
      if (key) {
        const parts = key.split("-");
        const isInternal = parts[0] === "ikv";
        const timestamp = parseInt(parts[2]);
        const daysElapsed = timestamp ? Math.floor((replicant.now() - timestamp) / 1e3 / 60 / 60 / 24) : void 0;
        const analyticsData = {
          key,
          channel: entryData.$channel,
          feature: entryData.feature,
          subFeature: entryData.$subFeature,
          playerID: entryData.playerID,
          daysElapsed
        };
        try {
          const payload = await (isInternal ? replicant.internalKvStore.get(key) : replicant.kvStore.get(key));
          if (!payload) {
            trackPayloadReadFailure(analytics, void 0, {
              ...analyticsData,
              type: "notFound"
            });
            return;
          }
          try {
            return JSON.parse(payload);
          } catch (error) {
            trackPayloadReadFailure(analytics, error, {
              ...analyticsData,
              type: "parseFailed"
            });
          }
        } catch (error) {
          trackPayloadReadFailure(analytics, error, {
            ...analyticsData,
            type: "kvStoreFetchFailed"
          });
        }
      }
    }
  };
  return payloadEncoder;
}
function createPayloadKeyGenerator(getReplicant) {
  let counter = 0;
  return () => {
    const replicant = getReplicant();
    return [
      replicant.userId,
      replicant.getChatbotSessionData().sessionId,
      replicant.now(),
      counter++,
      Math.random().toString(36).slice(2, 10)
    ].join("-");
  };
}
function trackPayloadReadFailure(analytics, error, props) {
  analytics.pushError("PayloadReadFailure", error, props);
}
function trackPayloadWriteFailure(analytics, error, props) {
  analytics.pushError("PayloadWriteFailure", error, props);
}
export {
  createPayloadEncoder
};
